import { isLocalMachine } from "../../utils/api/controlProxy";

const baseUrl = isLocalMachine() ? "/control" : "/d/control";

/**
 * GET_INTERNATIONAL_CITY_LIST_PDP
 * @param {*} productId
 * @returns
 */
export const GET_INTERNATIONAL_CITY_LIST_PDP = (productId) =>
  `${baseUrl}/getCityForIntlProducts-rj?productId=${productId}`;

/**
 * GET_INTERNATIONAL_CITY_LIST
 * @param {*} countryName
 * @returns
 */
export const GET_INTERNATIONAL_CITY_LIST = (countryName) => `/tiffany/v1/cities/country/${countryName}`;

export const GET_DELIVERY_KEY = `${baseUrl}/getDeliveryAreasAsKey`;
export const GET_LOCATION_LOCK_CONFIG_DATA =
  "/chocolate/v1/global/static/location-lock-config/location-lock-config-data";
export const NUDGE_FOR_SPECIFIC_CITY = "/global/static/web/nudge_for_specific_cities";
export const NUDGE_CITY_LIST = "nudgeCityList";
export const GET_INT_DELIVERY_RAKHI = "/global/static/getintdeliveryforrakhi";
